import { pathFor } from './pathFor'

export default function urlFor(resourceName, resource) {
  const scheme = process.env.NODE_ENV === 'development' ? 'http' : 'https'
  return `${scheme}://${window.location.host}${pathFor(resourceName, resource)}`
}
